import { useEffect, useRef, useState } from 'react';
import {
  NarvarEventComponents,
  NarvarEventTypes,
  useAnalyticsPost,
} from '../../../../../hooks/Analytics';
import { Shipment } from '../../../../../../../__generated__/loma';
import { usePageContext } from '../../../../../hooks/PageContext/usePageContext';

function useTrackQualityCarrierLogo(shipment: Shipment | null) {
  const [clientCarrierLogo, setClientCarrierLogo] = useState<string>();

  const {
    state: { carrier },
  } = usePageContext();

  const ref = useRef<HTMLImageElement>(null);

  const logEvent = useAnalyticsPost();

  // Force load image on client to track broken carrier logo image
  // https://github.com/facebook/react/issues/15446
  useEffect(() => {
    if (!shipment) return;
    setClientCarrierLogo(shipment.carrierLogoUrl);
  }, [shipment]);

  useEffect(() => {
    if (!ref.current) return;
    if (!shipment) return;

    const refCopy = ref.current;

    const handleError = () => {
      logEvent({
        eventComponent: NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventFeature: NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventType: NarvarEventTypes.TRACK_QUALITY,
        pageComponent: NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        pageCarrierService: carrier,
        requestPage: shipment.carrierLogoUrl,
      });
    };

    refCopy.addEventListener('error', handleError);

    return () => refCopy.removeEventListener('error', handleError);
  }, [ref, carrier, shipment, logEvent]);

  return { ref, clientCarrierLogo };
}

export { useTrackQualityCarrierLogo };
